module.exports = __webpack_public_path__ + "img/healthtech_orozco.370c9176.jpg";